import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: badges/BadgeDto.java. awardedAt is null whenever the badge hasn't been earned yet
// (BadgeService.badgesFor derives `awarded` from whether awarded_at is non-null). A secret badge
// the account hasn't earned is never represented by a row at all.
export type BadgeDto = {
  code: string;
  name: string;
  hint: string;
  awarded: boolean;
  awardedAt: string | null;
};

export type BadgesDto = {
  badges: BadgeDto[];
};

export const badgesKeys = {
  all: ['badges'] as const,
};

export const getBadges = () => apiFetch<BadgesDto>('/badges');

/** `enabled` (Studio Task 11 fix round 2): `MeScreen`'s logout mutation needs to disarm this
 *  observer for the duration of the request — see its own comment on why. Every other call site
 *  keeps the default. */
export function useBadges(enabled = true) {
  return useQuery({ queryKey: badgesKeys.all, queryFn: getBadges, enabled });
}
